import React, { useState } from "react";
import UploadReportModal from "./UploadReport";
import uploadIcon from "../../../../src/assets/images/upload_report.png";

const UploadReportButton = ({ patientId }) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <img
        src={uploadIcon}
        alt="Upload Report"
        onClick={() => setOpen(true)}
        style={{ width: "28px", height: "28px", cursor: "pointer" }}
        title="Upload Report"
      />

      <UploadReportModal
        show={open}
        onClose={() => setOpen(false)}
        patientId={patientId}
      />
    </>
  );
};

export default UploadReportButton;